import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { isStringNullOrEmpty } from '@wz-utilities/string.utilities';
import { PaymentModels } from 'models/payment.models';
import { ConfigurationModels } from '../../../../models/configuration.models';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseNavigationService {
  constructor(
    protected router: Router,
    protected config: ConfigurationModels.Configuration,
  ) {}

  public abstract getUrlFromKey(key: string): string;

  navigate(commands: any[]) {
    return this.router.navigate(commands);
  }

  navigateByUrl(url: string) {
    return this.router.navigateByUrl(url);
  }

  goToClientApp() {
    window.location.href = this.config.applicationPaths.appClientUrl;
  }

  goToBrokerApp(route: any = null) {
    this.goToUrl(this.config.applicationPaths.appBrokerUrl, route);
  }

  private goToUrl(baseUrl: string, route: any = null) {
    let url: string = baseUrl;

    if (!isStringNullOrEmpty(route)) {
      url += '/#' + route;
    }

    window.location.href = url;
  }

  abstract goToLogin(): any;
  abstract getAfterComplementPaymentRedirect(
    clientId: number,
    policyId: number,
  ): string;
  abstract getAfterReceiptsPaymentRedirect(
    clientId: number,
    policyId: number,
  ): string;
  abstract getAfterAvenantPaymentRedirect(
    clientId: number,
    policyId: number,
    requestPublicId: string,
  ): string;
  abstract getReceiptsPaymentRequest(
    clientId: number,
    policyId: number,
  ): PaymentModels.PaymentRequest;
  abstract getAvenantPaymentRequest(
    clientId: number,
    policyId: number,
  ): PaymentModels.PaymentRequest;
}
